const uniqueKey = "m_kdex_lc_handler";
const _ = require("lodash");

let _storage = window.localStorage || {
  getItem: () => ({}),
  setItem: () => ({}),
};
let storageData;

class LocalStorage {
  constructor() {
    storageData = JSON.parse(_storage.getItem(uniqueKey)) || {};
  }

  get(path, defaultValue) {
    return _.get(storageData, path, defaultValue);
  }

  set(path, value) {
    _.set(storageData, path, value);
    _storage.setItem(uniqueKey, JSON.stringify(storageData));
    return storageData;
  }

  delete(path) {
    _.unset(storageData, path);
    _storage.setItem(uniqueKey, JSON.stringify(storageData));
    return storageData;
  }
}

export default new LocalStorage();
